import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getDataContest } from '../redux/data/selectors'
import { useWeather, getForecast, describeForecast, getWeatherIcons, getContestDay, getSecondsNow, isToday, CONDITIONS } from '../tools/Weather'
import Icon from './Icon'
import Divider from './Divider'
import { WeatherCredit } from './WeatherStrip'

/**
 * How often the forecast looks at the clock, in ms
 * @type {number}
 */
const TICK = 60 * 1000

/**
 * Get the time of day, updated every minute
 * @returns {number} seconds since midnight
 */
const useSecondsNow = () =>
{
  const [ now, setNow ] = useState( getSecondsNow )

  useEffect( () =>
  {
    const timer = setInterval( () => setNow( getSecondsNow() ), TICK )
    return () => clearInterval( timer )
  }, [] )

  return now
}

/**
 * Show the weather at the circuit now and what changes in the coming hour, such as rain in 10
 * minutes, or that it stays the same, after the source of the data; only while the shown race is
 * today. The weather icons show what comes
 * @param {Object} props component props
 * @param {string} props.className extra class name
 * @param {boolean} props.credit whether the source is shown without a forecast too, for a screen
 *   that credits the weather in its charts here
 * @returns {JSX.Element|null} forecast, nothing without one unless the source is always shown
 */
const WeatherForecast = ( { className = '', credit = false } ) =>
{
  const day = getContestDay( useSelector( getDataContest ) )
  const weather = useWeather( isToday( day ) ? day : '' )
  const now = useSecondsNow()
  const forecast = getForecast( weather, now )

  if ( !forecast )
  {
    return credit ? <div className={ `weather-forecast ${ className }` }><WeatherCredit/></div> : null
  }

  const { change } = forecast

  return (
    <div className={ `weather-forecast ${ className }` } role="status">
      <WeatherCredit/>
      <Divider/>
      { /* the forecast without its source, which the kiosk screen can place on a row of its own */ }
      <span className="weather-forecast-main">
        <span className="weather-now" title={ CONDITIONS[ forecast.condition ].label }>
          <span className="weather-now-label">Now</span>
          { getWeatherIcons( forecast.condition, forecast.windy ).map( icon => <Icon key={ icon } icon={ icon }/> ) }
          { Math.round( forecast.temperature ) }°
        </span>
        <Divider/>
        <span className="weather-outlook">
          { change && getWeatherIcons( change.condition, change.windy ).map( icon => <Icon key={ icon } icon={ icon }/> ) }
          <span className="weather-outlook-text">{ describeForecast( forecast ) }</span>
        </span>
      </span>
    </div>
  )
}

export default WeatherForecast
